import React, {FC, useMemo} from 'react';
import CircularSlider, {
  CircularSliderProps,
} from '@fseehawer/react-circular-slider';
import KnobButtonSVG from './KnobButtonSVG';
import styled from 'styled-components';
import useMediaQuery from '../hooks/useMediaQuery';

interface Props {
  label?: string;
  labelColor?: string;
  prefixLabel?: string;
  suffixLabel?: string;
  min?: number;
  max?: number;
  // Only used for initial value
  initialValue?: number;
  width?: number;
  increment?: number;
  onChange?: (value: number) => void;
}

const Wrapper = styled.div`
  * {
    font-family: var(--font-family-head, vw-head, Helvetica, Arial, sans-serif);
  }
`;

const CircleSlider: FC<Props> = (props) => {
  const {
    label = ' ',
    labelColor = '#fff',
    suffixLabel,
    prefixLabel,
    min = 0,
    max = 100,
    width = 250,
    initialValue,
    onChange,
    increment,
  } = props;

  const {isMobile} = useMediaQuery();

  const dataProps: CircularSliderProps = useMemo(() => {
    if (!increment || increment === 1) {
      return {
        dataIndex: initialValue ? initialValue - 1 : 0,
        min,
        max,
      };
    }
    const data: number[] = [];

    let current = min;
    let initialIndex = 0;
    let hasFoundInitial = false;
    while (current <= max) {
      data.push(current);
      if (current === initialValue) {
        hasFoundInitial = true;
      }
      if (!hasFoundInitial) {
        initialIndex++;
      }
      current += increment;
    }

    return {
      data: data,
      dataIndex: initialIndex,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [increment, max, min]);

  return (
    <Wrapper>
      <CircularSlider
        trackSize={1}
        progressSize={2}
        knobSize={44}
        knobPosition={'top'}
        initialValue={initialValue}
        appendToValue={suffixLabel}
        prependToValue={prefixLabel}
        valueFontSize={isMobile ? '84px' : '96px'}
        labelBottom
        label={label}
        progressColorFrom={'rgba(255, 255,255, 1)'}
        progressColorTo={'rgba(255, 255,255, 1)'}
        trackColor={'rgba(255, 255,255, 0.1)'}
        labelColor={labelColor}
        width={width}
        onChange={onChange}
        {...dataProps}
      >
        <KnobButtonSVG />
      </CircularSlider>
    </Wrapper>
  );
};

export default CircleSlider;
